import React from "react";
import { BiInfoCircle } from "react-icons/bi";
import SaveImage from "../../ModalImages/SaveImage";
import SubmitImage from "../../ModalImages/SubmitImage"
import ListImage from "../../ModalImages/ListImage";
import DownIcon from "../../ModalImages/DownIcon";

function CommissionReceiptModal() {
  return (
    <div>
      <div class="d-flex justify-content-center align-items-center">
        <span class="modal-btn" data-toggle="modal" data-target="#myModal2">
          <BiInfoCircle />
        </span>
      </div>

      <div
        class="modal right fade my-modal"
        id="myModal2"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myModalLabel2"
      >
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title" id="myModalLabel2">
                Commission Receipt Info!
              </h4>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="modal-body">
              <ul className="modal-ul">
                <li>
                  <h5>
                    <SaveImage />
                    Save
                  </h5>
                  <ul>
                    <li>
                      <ListImage />
                      Simply data saved in table and available for update.
                    </li>
                  </ul>
                </li>
                <li>
                  <h5>
                    <SubmitImage />
                    Submit
                  </h5>
                  <ul>
                    <li>
                      <ListImage />
                      Update amount in contract’s commission
                    </li>
                    <li>
                      <DownIcon />
                      Transactions are:
                      <ul>
                        <li>
                          <ListImage />
                          Debit account = Cash/Bank account debit with voucher
                          amount.
                        </li>
                        <li>
                          <ListImage />
                          Credit account = ‘ DealName + "S DEAL COMM. R/A" ‘
                          account credit with voucher amount.
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CommissionReceiptModal;
